import encodeForUrl from './encodeForUrl'
import offerSlugBuy from './offerSlugBuy'
import resolveLinkBase from './offerResolveLinkBase'

const offerLinkBuy = (offer) => {
    const linkBase = resolveLinkBase(offer, true)

    if (!linkBase) return '/'

    const tracking = offer.tracking || {}

    const id = offer._shortid
    const lang = tracking.lang && tracking.lang.toLowerCase() || 'pl'
    const slug = encodeForUrl(offerSlugBuy(offer) || 'bez-tytulu')

    return [linkBase, 'oferta', slug, id, lang].join('/')
}



export default offerLinkBuy